<template>
  <div class="six-digit-wrapper">
    <input
      v-for="(item, index) in digits"
      :key="index"
      :ref="`ref${index}`"
      class="input"
      v-model="item.value"
      type="password"
      oninput="value=value.replace(/[^\d]/g,'')"
      @input="onInput(index)"
      @keyup.delete="onDelete(index)"
      maxlength="1"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      digits: [
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        }
      ]
    };
  },
  watch: {
    // 父组件向子组件传值并监听
    message(val) {
      if (val === true) {
        // window.console.log("哈哈  我变了");
        this.code = '';
      }
    }
  },
  created() {
    // 页面初始聚焦
    this.$nextTick((res) => {
      this.$refs['ref' + 0][0].focus();
    });
  },
  methods: {
    // 重置密码为空
    reset() {
      this.digits.forEach((o) => {
        o.value = '';
      });
      this.$refs['ref' + 0][0].focus();
    },
    // input 输入事件
    onInput(index) {
      // index < 5 ，如果是第6格，不触发光标移动至下一个输入框。
      if (this.digits[index].value && index < 5) {
        this.$refs['ref' + (index + 1)][0].focus();
      }
      const password = [];
      if (index === 5) {
        this.digits.map((item) => {
          password.push(item.value);
        });

        this.$emit('retrun', password.join(''));
      }
    },
    // input 删除事件
    onDelete(index) {
      // 如果是第1格，不触发光标移动至上一个输入框
      if (index > 0) {
        this.$refs['ref' + (index - 1)][0].focus();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.six-digit-wrapper {
  display: flex;
  flex-direction: row;
  .input {
    display: flex;
    width: 30px;
    height: 30px;
    font-size: 18px;
    color: #333333;
    margin-right: 5px;
    background-color: #fff;
    text-align: center;
    outline: none; // 去除选中状态边框
    border: solid 1px #d2d2d2;
    border-radius: 5px;
    // border-top: 0px;
    // border-left: 0px;
    // border-right: 0px;
  }
}
</style>
